import {EyeOutlined, InfoCircleOutlined} from '@ant-design/icons';
import {Button, Divider, Form, Select, Switch, Tooltip} from 'antd';
import React, {useEffect, useState} from 'react';
import {apiSplitPlans} from '../../../../../api/splitPlans';
import AccountsSearchSelect from '../../../../common/AccountsSearchSelect';
import './DivisionFees.scss';

const {Option} = Select;

const DivisionFees = ({data, onSave, onDiscard, setUnsavedChanges, setDataToSave}) => {
    const [feePlanOptions, setFeePlanOptions] = useState([]);
    const [feePlanLoading, setFeePlanLoading] = useState(false);
    const [enableEdit, setEnableEdit] = useState(false);
    const [localData, setLocalData] = useState(data);
    const [originalData, setOriginalData] = useState(data);    const [errors, setErrors] = useState({});

    const fetchFeePlans = async (value = '') => {
        setFeePlanLoading(true);
        try {
            const response = await apiSplitPlans({search: value});
            setFeePlanOptions(response.results.map(item => ({
                value: item.id,
                label: item.name
            })));
        } catch (error) {
            console.error("Erro ao buscar planos de taxa:", error);
        } finally {
            setFeePlanLoading(false);        }
    };

    useEffect(() => {
        if (data) {
            const updatedData = {
                ...data,
                split: {
                    ...data.split,
                    plan: data?.split?.plan ? data?.split?.plan.id : null,
                }            };
            setLocalData(updatedData);
            setOriginalData(updatedData);

            if (data?.split?.plan) {
                setFeePlanOptions(prev => [
                    ...prev,
                    {value: data?.split?.plan?.id, label: data?.split?.plan?.name}
                ]);
            }
        }

        fetchFeePlans();
    }, [data]);    
    
    useEffect(() => {
        if (localData) {
            setDataToSave(getChangedFields(localData, originalData));
            validateFields(localData);
        }
    }, [localData, originalData, setDataToSave]);

    const validateFields = (data) => {
        const newErrors = {};
        if (!data?.split?.n1_distributor) newErrors.n1_distributor = 'Campo obrigatório';
        if (!data?.split?.n2_distributor) newErrors.n2_distributor = 'Campo obrigatório';
        if (!data?.split?.agent) newErrors.agent = 'Campo obrigatório';
        if (!data?.split?.developer) newErrors.developer = 'Campo obrigatório';
        if (!data?.split?.plan) newErrors.plan = 'Campo obrigatório';
        setErrors(newErrors);
        return newErrors;
    };

    const getChangedFields = (currentData, originalData) => {
        currentData = {
            ...currentData,
            split: {
                ...currentData.split,
                n1_distributor: currentData?.split?.n1_distributor ? currentData?.split.n1_distributor.id : null,
                n2_distributor: currentData?.split?.n2_distributor ? currentData?.split.n2_distributor.id : null,
                agent: currentData?.split?.agent ? currentData?.split?.agent.id : null,
                developer: currentData?.split?.developer ? currentData?.split?.developer.id : null,
                redirect_sales_to: currentData?.split?.redirect_sales_to ? currentData?.split?.redirect_sales_to.id : null,
            }
        }
        originalData = {
            ...originalData,
            split: {
                ...originalData.split,
                n1_distributor: originalData?.split?.n1_distributor ? originalData?.split?.n1_distributor.id : null,
                n2_distributor: originalData?.split?.n2_distributor ? originalData?.split?.n2_distributor.id : null,
                agent: originalData?.split?.agent ? originalData?.split?.agent.id : null,
                developer: originalData?.split?.developer ? originalData?.split?.developer.id : null,
                redirect_sales_to: originalData?.split?.redirect_sales_to ? originalData?.split?.redirect_sales_to.id : null,
            }
        };

        const changedFields = {};

        const checkChanges = (current, original, path = '') => {
            for (const key in current) {
                if (current[key] !== original[key]) {
                    if (typeof current[key] === 'object' && current[key] !== null) {
                        checkChanges(current[key], original[key] || {}, `${path}${key}.`);
                    } else {
                        changedFields[`${path}${key}`] = current[key];
                    }
                }
            }
        };

        checkChanges(currentData, originalData);
        return changedFields;
    };

    const handleSave = async () => {
        const newErrors = validateFields(localData);
        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            try {
                const changes = getChangedFields(localData, originalData);
                if (Object.keys(changes).length > 0) {
                    await onSave(changes);
                    setOriginalData(localData);
                }

                setEnableEdit(false);
                setUnsavedChanges(false);
            } catch (error) {
                console.error("Erro ao salvar as mudanças:", error);
                alert('Ocorreu um erro ao salvar. Tente novamente.');
            }
        } else {
            alert('Por favor, corrija os campos obrigatórios.');
        }
    };

    const handleDiscard = async () => {
        await onDiscard();
        setEnableEdit(false);
        setUnsavedChanges(false);
    };

    const handleSelectChange = (value, field) => {
        setLocalData(prevData => {
            const newData = {
                ...prevData,
                split: {
                    ...prevData.split,
                    [field]: value
                }
            };
            setUnsavedChanges(true);
            validateFields(newData);
            return newData;        
        });
    };

    return (
        <div className='DivisionFees'>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <p className='subtitle-page'>Divisão de Taxas</p>
                <Button
                    onClick={() => setEnableEdit(!enableEdit)}
                    type={enableEdit ? "primary" : ""}
                >
                    {enableEdit ? "Cancelar" : "Editar"}
                </Button>
            </div>
            <Divider/>
            <div className="container-inputs">
                <div className="left-inputs">
                    <Form layout="vertical">
                        <Form.Item label="Plano de Taxa">
                            <div className='input-container'>                                
                                <Select
                                    showSearch
                                    value={localData?.split?.plan || undefined}
                                    className={errors.plan ? 'error-select' : ''}
                                    placeholder="Selecione um plano de taxa"
                                    onChange={(value) => handleSelectChange(value, 'plan')}
                                    onSearch={(value) => fetchFeePlans(value)}
                                    onDropdownVisibleChange={(visible) => {
                                        if (visible) {
                                            fetchFeePlans('');
                                        }
                                    }}
                                    notFoundContent={feePlanLoading ? "Carregando..." : "Nenhum plano de taxa encontrado"}
                                    style={{width: '100%'}}
                                    filterOption={false}
                                    loading={feePlanLoading}
                                    disabled={!enableEdit}
                                >
                                    {feePlanOptions.map(option => (
                                        <Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Option>
                                    ))}
                                </Select>
                                {localData?.split?.plan && (
                                    <EyeOutlined
                                        onClick={() => window.open(`/planos-e-taxas/detalhe/${localData.split.plan}`, "_blank")}
                                        className='eye-icon'
                                    />
                                )}                            </div>
                            {errors.plan && <div className="error-text">{errors.plan}</div>}
                        </Form.Item>
                        <Form.Item label="Agente">
                            <AccountsSearchSelect
                                value={localData?.split?.agent}
                                onChange={(value) => handleSelectChange(value, 'agent')}
                                placeholder="Selecione um agente"
                                hasError={!!errors.agent}
                                disabled={!enableEdit}
                                notFoundText="Nenhum agente encontrado"
                                showEyeIcon={true}
                                eyeIconUrl="/lojista/detalhes/{id}"
                                errorMessage={errors.agent}
                            />
                        </Form.Item>
                        <Form.Item label="Desenvolvedor">
                            <AccountsSearchSelect
                                value={localData?.split?.developer}
                                onChange={(value) => handleSelectChange(value, 'developer')}
                                placeholder="Selecione um desenvolvedor"
                                hasError={!!errors.developer}
                                disabled={!enableEdit}
                                notFoundText="Nenhum desenvolvedor encontrado"
                                showEyeIcon={true}
                                eyeIconUrl="/lojista/detalhes/{id}"
                                errorMessage={errors.developer}
                            />
                        </Form.Item>
                    </Form>
                </div>
                <div className="right-inputs">
                    <Form layout="vertical">                        <Form.Item label="Distribuidor N1">
                            <AccountsSearchSelect
                                value={localData?.split?.n1_distributor}
                                onChange={(value) => handleSelectChange(value, 'n1_distributor')}
                                placeholder="Selecione um distribuidor N1"
                                hasError={!!errors.n1_distributor}
                                disabled={!enableEdit}
                                notFoundText="Nenhum distribuidor encontrado"
                                showEyeIcon={true}
                                eyeIconUrl="/lojista/detalhes/{id}"
                                errorMessage={errors.n1_distributor}
                            />
                        </Form.Item>                        <Form.Item label="Distribuidor N2">
                            <AccountsSearchSelect
                                value={localData?.split?.n2_distributor}
                                onChange={(value) => handleSelectChange(value, 'n2_distributor')}
                                placeholder="Selecione um distribuidor N2"
                                hasError={!!errors.n2_distributor}
                                disabled={!enableEdit}
                                notFoundText="Nenhum distribuidor encontrado"
                                showEyeIcon={true}
                                eyeIconUrl="/lojista/detalhes/{id}"
                                errorMessage={errors.n2_distributor}
                            />
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <p className='subtitle-page'>Opções avançadas</p>
            <Divider/>
            <div className="container-inputs">
                <div className="left-inputs">
                    <Form layout="vertical">
                        <Form.Item label="Redirecionar vendas para">
                            <AccountsSearchSelect
                                value={localData?.split?.redirect_sales_to}
                                onChange={(value) => handleSelectChange(value, 'redirect_sales_to')}
                                placeholder="Selecione uma conta"
                                hasError={!!errors.redirect_sales_to}
                                disabled={!enableEdit}
                                notFoundText="Nenhuma conta encontrada"
                                showEyeIcon={true}
                                allowClear={true}
                                eyeIconUrl="/lojista/detalhes/{id}"
                                errorMessage={errors.redirect_sales_to}
                            />
                        </Form.Item>
                    </Form>
                </div>
                <div className="right-inputs">
                    <Form layout="vertical">
                        <Form.Item label={
                            <Tooltip
                                placement="topRight"
                                title={"Define se a DLPay será a responsável pela criação dos splits"}
                            >
                                Gerenciado pelo Sistema <InfoCircleOutlined/>
                            </Tooltip>
                        }>
                            <div className='input-container'>
                                <Switch
                                    checked={localData?.split?.is_system_managed}
                                    onChange={(value) => handleSelectChange(value, 'is_system_managed')}
                                    disabled={!enableEdit}
                                />
                            </div>
                            {errors.is_system_managed && <div className="error-text">{errors.is_system_managed}</div>}
                        </Form.Item>
                    </Form>
                </div>
            </div>
            {
                enableEdit && (
                    <div style={{width: "100%", display: "flex", justifyContent: "flex-end", gap: 10}}>
                        <Button onClick={handleSave} type="primary">Salvar</Button>
                        <Button onClick={handleDiscard}>Descartar</Button>
                    </div>
                )
            }
        </div>
    );
};

export default DivisionFees;
